import { createContext, type Context } from 'react';

// Mirrors the `Apps` type from `@townsquare/app-context`. Duplicated here to avoid a circular
// dependency between `user-profile-card` (platform) and `@townsquare/app-context` (townsquare).
// If the upstream type gains or loses members, update this union to match.
export type TownsquareApp =
	| 'home'
	| 'goals'
	| 'teams'
	| 'focus'
	| 'projects'
	| 'teams-isolated'
	| 'rovo';

type UserProfileCardContextValues = {
	cloudId: string;
	townsquareApp?: TownsquareApp;
	onProfileClick?: (userId: string) => void;
	getTestId: (suffix: string) => string | undefined;
};

/** Sentinel identity used to detect "no outer provider" without an explicit flag. */
const defaultGetTestId: UserProfileCardContextValues['getTestId'] = () => undefined;

const UserProfileCardContext: Context<UserProfileCardContextValues> =
	createContext<UserProfileCardContextValues>({
		cloudId: '',
		townsquareApp: undefined,
		onProfileClick: undefined,
		getTestId: defaultGetTestId,
	});

export { UserProfileCardContext, defaultGetTestId };
export type { UserProfileCardContextValues };
